import {customElement, property} from 'lit/decorators.js';
import {html, LitElement} from 'lit';
import type {TemplateResult} from 'lit';
import {classMap} from 'lit/directives/class-map.js';

export type Notification = {
  type: 'success' | 'information' | 'error';
  message?: string;
  html?: TemplateResult;
};

@customElement('element-notifications')
export default class ElementNotifications extends LitElement {
  @property({type: Object}) notification?: Notification = null;
  private _timeout: ReturnType<typeof setTimeout>;

  sendNotification(notification: Notification, duration = 5000) {
    this.notification = notification;
    this._timeout = setTimeout(() => {
      this._resetNotification();
    }, duration);
  }

  onClick() {
    this._resetNotification();
  }

  _resetNotification() {
    clearTimeout(this._timeout);
    this.notification = null;
  }

  override render() {
    const n = this.notification;
    return html` <div
      id="alerts-body"
      @click="${() => this.onClick()}"
      class="${classMap({
        'cursor-pointer': n?.message,
        hidden: !n?.message && !n?.html,
        'notification-success': n?.type === 'success',
        'notification-error': n?.type === 'error',
        'notification-information': n?.type === 'information',
      })}
      rounded-[8px] px-[16px] py-[12px] text-body
      shadow-snackbar md:text-md-body
      lg:text-lg-body"
      role="alert"
    >
      ${n?.html ? n?.html : html`<span>${n?.message}</span>`}
    </div>`;
  }

  override createRenderRoot() {
    return this;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'element-notifications': ElementNotifications;
  }
}
